import { TrackedSerialNumbersService } from "../api/generated/TrackedSerialNumbersService";
import {
  PagedDataTableConfig,
  renderViewButton,
  usePagedDataTable,
} from "../hooks/paged-data-table/use-paged-data-table";
import { BasicPage } from "../components/basic-page";
import { ROUTES } from "../routes";
import { SnEnabledPartnerSiteDto } from "../api/generated/index.defs.ts";

export const SnTrackingSitesListing = () => {
  const pagedDataTable = usePagedDataTable(
    TrackedSerialNumbersService.getSnEnabledSites,
    TableConfig,
  );

  return <BasicPage title="Serial Number Tracking">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(
  TrackedSerialNumbersService.getSnEnabledSites,
  {
    columns: [
      {
        accessor: "",
        title: "",
        render: (item: SnEnabledPartnerSiteDto) =>
          renderViewButton({
            item: { ...item, id: Number(item.id) },
            descriptor: "tracked serial numbers",
            route: ROUTES.ADMIN.SERIAL_NUMBER_TRACKING.DETAIL.path,
          }),
      },
      {
        accessor: "name",
        title: "Partner Site",
        sortable: true,
      },
      {
        accessor: "arfNumber",
        title: "ARF Number",
        sortable: true,
      },
      {
        accessor: "rigCount",
        title: "Rigs",
        sortable: false,
      },
      {
        accessor: "trackedSerialNumberCount",
        title: "Tracked Serial Numbers",
        sortable: false,
      },
    ],
    defaultSort: {
      column: "name",
      direction: "ASC",
    },
    searchFieldNames: ["name", "arfNumber"],
  },
);